import {Section} from "./Section";

export default Section;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Section/index.tsx